// Detalles de cliente

import React, { useEffect, useState } from "react";
import {
  Button,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Box,
  Paper
} from "@mui/material";
import { apiFetchJson } from '../fetchWrapper';
import SiteList from "./SiteList";

export default function ClientDetails({ client, onBack }) {
  const [localClient, setLocalClient] = useState(client);
  const [sites, setSites] = useState([]);
  const [loading, setLoading] = useState(true);

  if (!client) {
    return (
      <div>
        <button onClick={onBack}>Volver</button>
        <p>No se ha seleccionado ninguna cotización.</p>
      </div>
    );
  }

  useEffect(() => {
    setLoading(true);

    if (!localClient) {
      setLoading(false);
      return;
    }

    const url = `/api/clients/${localClient.id}/sites`;

    apiFetchJson(url)
      .then(setSites)
      .catch((err) => {
        console.error('Failed to load sites', err);
        setError(err.message || 'Failed to load');
      })
      .finally(() => setLoading(false));
  }, [localClient]);

  const handleAdd = async (id) => {
    setEditingSite(null);
    setShowForm(true);
  }

  return (
    <Box >

      <Button onClick={onBack}
        sx={{
          backgroundColor: "#3f74b1",
          color: "#fff",
          "&:hover": {
            backgroundColor: "#364f6b"
          }
        }}
      >
        Volver
      </Button>
      <h2>Detalles del cliente:</h2>

      <TableContainer component={Paper} sx={{ mb: 2 }}>
        <Table>

          <TableBody>
            <TableRow>
              <TableCell><strong>Nombre:</strong></TableCell>
              <TableCell> {localClient.companyName}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Contacto:</strong></TableCell>
              <TableCell> {client.contactPerson.firstname} {client.contactPerson.lastnameFirst}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>RFC</strong></TableCell>
              <TableCell>{client.rfc}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Email</strong></TableCell>
              <TableCell>{client.contactPerson.email}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Teléfono</strong></TableCell>
              <TableCell>{client.contactPerson.phoneNumber}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Teléfono Móvil</strong></TableCell>
              <TableCell>{client.contactPerson.mobileNumber}</TableCell>
            </TableRow>

          </TableBody>
        </Table>
      </TableContainer>

      <Box>
        <SiteList clientId={localClient.id} disableActions={false} />
      </Box>
    </Box>
  );
}